// utils/transformFilters.ts

export interface FilterCondition {
  field: string;
  operator: string;
  value?: any;
}

export interface TransformedFilters {
  logic: 'AND';
  conditions: FilterCondition[];
}

export function transformFilters(filters: Record<string, any>): TransformedFilters {
  const conditions = Object.entries(filters)
    .filter(([_, value]) => {
      if (value === undefined || value === null) return false;
      if (Array.isArray(value) && value.length === 0) return false;
      if (typeof value === 'string' && value.trim() === '') return false;
      return true;
    })
    .map(([field, value]) => {
      const isDateField = field.toLowerCase().includes('date') || field.toLowerCase().includes('created_at');

      let operator: string = 'equals';
      let finalValue: any = value;

      if (typeof value === 'string') {
        const trimmed = value.trim().toLowerCase();
        if (trimmed === 'yes') return { field, operator: 'isNotNull' };
        if (trimmed === 'no') return { field, operator: 'isNull' };
      }

      if (Array.isArray(value)) {
        const isArrayOfNumericStrings = value.every(v => typeof v === 'string' && !isNaN(Number(v)));
        // const numericValue = value.map(v => Number(v));
        const numericValue = value.map(v => v);

        if (isDateField) {
          operator = 'between';
          finalValue = value;
        } else if (isArrayOfNumericStrings && value.length === 2) {
          operator = 'between';
          finalValue = numericValue;
        } else {
          operator = field.startsWith('field:') ? 'contains' : 'in';
          finalValue = operator === 'contains' ? JSON.stringify(value) : value;
        }
      }

      return { field, operator, value: finalValue };
    });

  return {
    logic: 'AND',
    conditions,
  };
}
